import { render, staticRenderFns } from "./stay.vue?vue&type=template&id=1fab7888"
import script from "./stay.vue?vue&type=script&lang=js"
export * from "./stay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports